module.exports = __webpack_public_path__ + "img/Weapon_184.0e8b389c.png";